import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll);
  }

  onScroll() {
    const scrolled = window.scrollY > 12;
    this.element.classList.toggle("nav--scrolled", scrolled);
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden");
  }

  close() {
    this.menuTarget.classList.add("hidden");
  }
}
